import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Layout main element, used to wrap all content within the default width (1400px)
 *
 * @slot - Unnamed slot (default)
 *
 */
let SDBLayoutMain = class SDBLayoutMain extends LitElement {
    render() {
        return html ` <slot></slot> `;
    }
};
SDBLayoutMain.styles = [
    elements,
    css `
            :host {
                display: block;
                max-width: 1400px;
                width: calc(100% - 60px);
                padding: 0 30px;
                margin: 0 auto;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    padding: 0 15px;
                    width: calc(100% - 30px);
                }
            }
        `,
];
SDBLayoutMain = __decorate([
    customElement('sdb-layout-main')
], SDBLayoutMain);
export { SDBLayoutMain };
//# sourceMappingURL=sdb-layout-main.js.map